// The open game's heartbeat for timed effects that pause while it is closed —
// the Dark Shard, "time does not deplete when you are offline" (spec
// docs/superpowers/specs/2026-10-07-dark-shadows-three-levels-design.md).
//
// Every EFFECT_HEARTBEAT_MS, and the moment the tab comes back into view, the
// running paused-offline effects are stamped `seenAt = now`; a gap since the
// last stamp longer than the grace was the game being closed and is added to
// their end (config/effects `heartbeatEffects`). It writes ONLY while such an
// effect runs, so a save without one never sees an extra push. Installed once
// from main.ts, alongside the restock watch.
import { EFFECT_HEARTBEAT_MS } from '../config/effects';
import { hubProgress } from '../render/hubShared';

let timer: ReturnType<typeof setInterval> | undefined;

function beat(now: number): void {
  try {
    hubProgress().heartbeatEffects(now);
  } catch (err) {
    console.warn('[effectHeartbeat] failed', err);
  }
}

export function installEffectHeartbeat(now: () => number = Date.now): void {
  if (timer) return;
  beat(now());
  timer = setInterval(() => beat(now()), EFFECT_HEARTBEAT_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') beat(now());
  });
}
